import { render, staticRenderFns } from "./WhatToRead.vue?vue&type=template&id=51d82f78&"
import script from "./WhatToRead.vue?vue&type=script&lang=js&"
export * from "./WhatToRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WhatToRead.vue"
export default component.exports